module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwWiIgc3R5bGU9ImZpbGw6bm9uZSIvPjxwYXRoIGQ9Ik0zMC4xMjMgMTA4Ljg5M2E3LjcgNy43IDAgMCAwLTcuNyA3LjdjMCA1Ljc3NSA3LjcgMTQuMyA3LjcgMTQuM3M3LjctOC41MjYgNy43LTE0LjNhNy42OTMgNy42OTMgMCAwIDAtNy43LTcuN1ptMCAxMC40NTFhMi43NTEgMi43NTEgMCAxIDEgMi43NDgtMi43NTIgMi43NTIgMi43NTIgMCAwIDEtMi43NDggMi43NTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTguMTIxIC0xMDcuODkzKSIgc3R5bGU9ImZpbGw6I2ZmZjtvcGFjaXR5Oi43Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_local.svg
// module id = ggfL
// module chunks = 98